import { Link } from 'react-router-dom';
import navItems from '../../Json/header.json'
import AnimatedComponent from '../AnimateComponent';

const LandingBanner = () => {
    return (
        <div className="w-full  h-fit flex justify-between bg-landingbannerbg bg-cover bg-center bg-no-repeat max-sm:bg-landingbannermb">
            <div className="2xl:container mx-auto md:px-14 lg:px-20 px-6 w-full flex flex-col justify-between gap-y-20 md:gap-y-[110px]">
                <AnimatedComponent delay={0.1}>
                    <div className="w-full md:w-[90%] lg:w-[70%] pt-[100px] w-full flex flex-col items-center md:items-start text-center md:text-left gap-y-10">
                        <h1 className=" text-28 sm:text-32 md:text-56 text-white font-semibold">{navItems.banner.heading}</h1>
                        <p className='text-white w-[90%] md:w-2/3 text-18 md:text-20 font-regular opacity-75'>{navItems.banner.desc}</p>
                        <div className="flex justify-center md:justify-start mt-4">
                            <Link
                                to={"/login/signin"}
                                className="py-[16px] md:py-[21px] px-[40px] bg-orange rounded-full hover:bg-btnhover hover-text-white"
                            >
                                <p className="text-18 font-semibold text-white ">
                                    Get started
                                </p>
                            </Link>
                        </div>

                    </div>
                </AnimatedComponent>

                <AnimatedComponent delay={0.2}>
                    <div className="flex gap-x-4 gap-y-10 w-full max-md:flex-col max-md:items-center max-md:w-full">
                        <img
                            className='md:w-[30%] sm:w-[70%] w-[80%]'
                            src={process.env.PUBLIC_URL + "/images/landing-page/banner/banner-left.jpg"}
                            alt="banner_img"
                        />
                        <img className='w-[70%] h-fit max-md:w-full'
                            src={process.env.PUBLIC_URL + "/images/landing-page/banner/banner-right.jpg"}
                            alt="banner_img"
                        />
                    </div>
                </AnimatedComponent>

            </div>

        </div>
    )
}
export default LandingBanner;